<template>
    <div class="table">
        <div class="crumbs" style="float:left">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{ menuName }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div  v-if="pendingRefundCount > 0" style="float:right;color:red;font-size: 16px;"">
            有{{ pendingRefundCount }}笔退款订单需要处理
        </div>

        <div class="container" style="float:right;width:95%;">
            <div style="margin:5px 0 10px 0; line-height: 40px;">
                <div style="display: inline-block; height:40px;">
                    <el-select
                        v-model="queryForm.schoolId"
                        placeholder="请选择学校"
                        filterable
                        style="width: 180px;">
                        <el-option
                            v-for="item in schoolOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div style="display: inline-block; height:40px; margin-left: 10px;">
                    <el-input v-model="queryForm.orderId" placeholder="订单号" clearable style="width: 160px;"></el-input>
                </div>
                <div style="display: inline-block; height:40px; margin-left: 10px;">
                    <el-input v-model="queryForm.childName" placeholder="学生姓名" clearable style="width: 140px;"></el-input>
                </div>
                <div style="display: inline-block; height:40px; margin-left: 10px;">
                    <el-input v-model="queryForm.childClassName" placeholder="学生班级" clearable style="width: 140px;"></el-input>
                </div>
                <div style="display: inline-block; height:40px; margin-left: 10px;">
                    <el-select v-model="queryForm.status" placeholder="状态" clearable style="width: 140px;">
                        <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div style="display: inline-block; height:40px; margin-left: 10px;">
                    <el-date-picker
                        v-model="queryForm.gmtCreateRange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="timestamp"
                        style="width: 360px;"
                        clearable>
                    </el-date-picker>
                </div>
                <div style="display: inline-block; height:40px; margin-left: 10px;">
                    <el-button type="primary" icon="search" @click="common.page = 1; getData()">查询</el-button>
                    <el-button @click="resetQuery">重置</el-button>
                    <el-button type="success" :loading="exportLoading" @click="exportCardReport">导出制卡报表</el-button>
                </div>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                height="550"
                row-key="id"
                border
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)">
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
                <el-table-column prop="orderId" label="订单号" min-width="180" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="childName" label="学生姓名" width="100"></el-table-column>
                <el-table-column prop="childClassName" label="学生班级" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="parentName" label="家长姓名" width="100"></el-table-column>
                <el-table-column label="购买商品" min-width="180" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ formatProduct(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="订单金额" width="100">
                    <template slot-scope="scope">
                        {{ formatAmount(scope.row.amount) }}
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="110">
                    <template slot-scope="scope">
                        {{ statusLabel(scope.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="170">
                    <template slot-scope="scope">
                        {{ formatGmtCreate(scope.row.gmtCreate) }}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="openDetail(scope.row)">
                            <span style="color: #387EE8;">详情</span>
                        </el-button>
                        <el-dropdown
                            v-if="showMoreMenu(scope.row.status)"
                            trigger="click"
                            @command="(cmd) => handleMoreCommand(cmd, scope.row)">
                            <span class="el-dropdown-link" style="color: #387EE8;cursor: pointer;">
                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-if="showRefund(scope.row.status)" command="refund">退款</el-dropdown-item>
                                <el-dropdown-item v-if="showDelivery(scope.row.status)" command="delivery">发货</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>

        <div v-if="detailVisible">
            <orderDetail ref="orderDetail"></orderDetail>
        </div>
        <div v-if="deliveryVisible">
            <orderDelivery ref="orderDelivery"></orderDelivery>
        </div>
        <div v-if="refundVisible">
            <orderRefund ref="orderRefund"></orderRefund>
        </div>
    </div>
</template>

<script>
import http from '../../../../common/http';
import axios from 'axios';
import orderDetail from './OrderDetail.vue';
import orderDelivery from './OrderDelivery.vue';
import orderRefund from './OrderRefund.vue';
import memberOrderMixin from './memberOrderMixin';

export default {
    name: 'MemberOrder',
    mixins: [http, memberOrderMixin],
    components: {
        orderDetail,
        orderDelivery,
        orderRefund
    },
    data() {
        return {
            menuName: '',
            loading: false,
            loadingText: '',
            exportLoading: false,
            detailVisible: false,
            deliveryVisible: false,
            refundVisible: false,
            data: [],
            schoolOptions: [],
            queryForm: {
                schoolId: '',
                orderId: '',
                childName: '',
                childClassName: '',
                status: '',
                gmtCreateRange: []
            },
            common: {
                total: 0,
                pageSize: 30,
                page: 1,
                isPage: 1,
                allSizes: [30, 50, 100]
            },
            isAdmin: false,
            pendingRefundCount: 0
        };
    },
    created() {
        this.menuName = sessionStorage.getItem('selectMenuItem_key') || '';
        const userinfo = JSON.parse(sessionStorage.getItem('userinfo') || '{}');
        this.isAdmin = userinfo && userinfo.id == 1;
        this.getSchoolOptions(true);
    },
    methods: {
        indexMethod(index) {
            return (this.common.page - 1) * this.common.pageSize + (index + 1);
        },
        getSchoolOptions(loadListAfter) {
            const url = this.listDeptUrl;
            const data = { parentId: '0' };
            this.apiPost(url, data).then((res) => {
                if (res.status === 200) {
                    this.schoolOptions = res.data.list || [];
                    if (loadListAfter) {
                        this.applyDefaultSchool();
                        this.getData();
                    }
                } else {
                    this.$commonFn.showTip(res.message, 3);
                    if (loadListAfter) {
                        this.getData();
                    }
                }
            }, (err) => {
                console.log(err);
                if (loadListAfter) {
                    this.getData();
                }
            });
        },
        applyDefaultSchool() {
            if (this.schoolOptions.length > 0) {
                this.queryForm.schoolId = this.schoolOptions[0].id;
            } else {
                this.queryForm.schoolId = '';
            }
        },
        resetQuery() {
            this.applyDefaultSchool();
            this.queryForm.orderId = '';
            this.queryForm.childName = '';
            this.queryForm.childClassName = '';
            this.queryForm.status = '';
            this.queryForm.gmtCreateRange = [];
            this.common.page = 1;
            this.getData();
        },
        getQueryTimeRange() {
            let startTime = '';
            let endTime = '';
            if (this.$util.isNotEmpty(this.queryForm.gmtCreateRange) && this.queryForm.gmtCreateRange.length === 2) {
                startTime = this.toSecondTimestamp(this.queryForm.gmtCreateRange[0]);
                endTime = this.toSecondTimestamp(this.queryForm.gmtCreateRange[1]);
            }
            return { startTime, endTime };
        },
        getData() {
            this.loading = true;
            this.loadingText = '数据加载中...';
            const { startTime, endTime } = this.getQueryTimeRange();
            const url = this.memberOrderListUrl;
            const data = {
                isPage: this.common.isPage,
                page: this.common.page,
                limit: this.common.pageSize,
                deptId: this.queryForm.schoolId,
                orderId: this.queryForm.orderId,
                childName: this.queryForm.childName,
                childClassName: this.queryForm.childClassName,
                status: this.queryForm.status,
                startTime,
                endTime
            };
            this.apiPost(url, data).then((res) => {
                this.loading = false;
                if (res.status === 200) {
                    this.data = res.data.list || res.data.data || [];
                    this.common.total = res.data.total || 0;
                    this.getPendingRefundCount();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
                this.loading = false;
            });
        },
        handleSizeChange(val) {
            this.common.pageSize = val;
            this.common.page = 1;
            this.getData();
        },
        handleCurrentChange(val) {
            this.common.page = val;
            this.getData();
        },
        openDetail(row) {
            this.detailVisible = true;
            this.$nextTick(() => {
                this.$refs.orderDetail.init(row);
            });
        },
        openDelivery(row) {
            this.deliveryVisible = true;
            this.$nextTick(() => {
                this.$refs.orderDelivery.init(row, () => {
                    this.getData();
                });
            });
        },
        openRefund(row) {
            this.refundVisible = true;
            this.$nextTick(() => {
                this.$refs.orderRefund.init(row, () => {
                    this.getData();
                });
            });
        },
        showRefund(status) {
            if (!this.isAdmin) {
                return false;
            }
            const s = status == null ? '' : String(status);
            return s === '6';
        },
        showDelivery(status) {
            if (!this.isAdmin) {
                return false;
            }
            return String(status) === '1';
        },
        showMoreMenu(status) {
            if (!this.isAdmin) {
                return false;
            }
            return this.showRefund(status) || this.showDelivery(status);
        },
        handleMoreCommand(cmd, row) {
            if (cmd === 'refund') {
                if (!this.isAdmin || !this.showRefund(row.status)) {
                    return;
                }
                this.openRefund(row);
            } else if (cmd === 'delivery') {
                if (!this.isAdmin || !this.showDelivery(row.status)) {
                    return;
                }
                this.openDelivery(row);
            }
        },
        exportCardReport() {
            const loadingInstance = this.$loading({
                lock: true,
                fullscreen: true,
                text: '正在导出制卡报表，请耐心等待…',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const { startTime, endTime } = this.getQueryTimeRange();
            const url = this.memberOrderExportCardReportUrl;
            const param = new URLSearchParams();
            param.append('deptId', this.queryForm.schoolId);
            param.append('orderId', this.queryForm.orderId);
            param.append('childName', this.queryForm.childName);
            param.append('childClassName', this.queryForm.childClassName);
            param.append('status', this.queryForm.status);
            param.append('startTime', startTime);
            param.append('endTime', endTime);
            axios({
                method: 'post',
                url: url,
                data: param,
                responseType: 'blob'
            }).then(res => {
                const link = document.createElement('a');
                const blob = new Blob([res.data], { type: 'application/zip' });
                link.style.display = 'none';
                link.href = URL.createObjectURL(blob);
                link.setAttribute('download', '制卡报表.zip');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                loadingInstance.close();
            }).catch(err => {
                console.log(err);
                loadingInstance.close();
            });
        },
        getPendingRefundCount() {
            const url = this.memberOrderPendingRefundCountUrl;
            this.apiPost(url, {deptId: this.queryForm.schoolId}).then((res) => {
                if (res.status === 200) {
                    this.pendingRefundCount = res.data || 0;
                }
            }, (err) => {
                console.log(err);
            });
        }
    }
};
</script>

<style scoped>
.table {
    width: 100%;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/member/order/MemberOrder.vue